import { render, staticRenderFns } from "./BanWarnDialog.vue?vue&type=template&id=607c2094&scoped=true&"
import script from "./BanWarnDialog.vue?vue&type=script&lang=js&"
export * from "./BanWarnDialog.vue?vue&type=script&lang=js&"
import style0 from "./BanWarnDialog.vue?vue&type=style&index=0&id=607c2094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607c2094",
  null
  
)

export default component.exports